import AlertIcon from '@components/alerticon';
import Typography from '@components/typography';
import { getNonQuotableButton } from '../../constants';
import { ModalContent } from 'interface';
import { getVehicleSearchURL } from '@navigation/constants';

export const nonQuotable = (make: string) => {
  const capitalize = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };
  const buttons = (
    <a
      className="modal-content__body-buttons-button modal-content__body-buttons-button--primary modal-content__body-buttons-button--nonquotable"
      data-testid="nonquotable-view-button"
      href={getVehicleSearchURL(make.toLowerCase())}
    >
      <Typography
        variant="caption"
        size="rg"
        weight="semi-bold"
        colour="alternative"
      >
        {getNonQuotableButton(capitalize(make))}
      </Typography>
    </a>
  );
  return {
    icon: <AlertIcon />,
    title: "Sorry, this car isn't available any more",
    message: 'While we work on getting some more, check out our other deals.',
    buttons: buttons,
  } as ModalContent;
};
